import { getHelperText } from "ds_legacy/components/Validation";
import {
  FormElementProps,
  FormElementRenderProps,
  isValid,
} from "react-forms-state/src";
import { useTranslations } from "translations";
import { PasswordInput, PasswordInputProps } from "./password-input";

export function ConnectedPasswordInput({
  debug,
  elementName,
  onChange,
  sideMutation,
  validation,
  value,
  withFlatModel,
  ...inputProps
}: FormElementProps & PasswordInputProps) {
  const translations = useTranslations();

  return (
    <FormElementRenderProps
      debug={debug}
      elementName={elementName}
      sideMutation={sideMutation}
      validation={validation}
      value={value}
      withFlatModel={withFlatModel}
      onChange={onChange}
    >
      {({ onChange, validation, value }) => {
        return (
          <PasswordInput
            {...inputProps}
            errorMessage={
              getHelperText({
                hasCustomValidation: true,
                translations,
                validateOverride: undefined,
                validation,
              }) || inputProps.errorMessage
            }
            isInvalid={!isValid(validation) || inputProps.isInvalid}
            name={elementName}
            value={value ?? ""}
            onValueChange={(value) => onChange(value)}
          />
        );
      }}
    </FormElementRenderProps>
  );
}

ConnectedPasswordInput.displayName = "RecareUI.ConnectedPasswordInput";
